import { Channel } from 'client/model/skill';
import mem from 'mem';

import { routes } from '../../lib/routes';
import { MarketDevice } from '../../model/devices';
import { callApi } from '../utils';

export const getDeviceList = (skillId: string, channel: Channel, isDraft = false) => {
    const suffix = isDraft ? '/drafts' : '';
    return callApi<MarketDevice[]>({
        method: 'GET',
        url: routes.app.appStoreApi(`/apps/${skillId}/market-devices${suffix}`),
        queryParams: { channel },
    });
};

export const addDevice = (skillId: string, deviceId: string, channel: Channel, requireOsku = false) => {
    return callApi<MarketDevice>({
        method: 'POST',
        url: routes.app.appStoreApi(`/apps/${skillId}/market-devices/drafts`),
        data: { marketId: deviceId, requireOsku },
        queryParams: { channel },
    });
};

export const addPublishedDevice = (skillId: string, deviceId: string, channel: Channel, requireOsku = false) => {
    return callApi<MarketDevice>({
        method: 'POST',
        url: routes.app.appStoreApi(`/apps/${skillId}/market-devices`),
        data: { marketId: deviceId, requireOsku },
        queryParams: { channel },
    });
};

export const deleteDevice = (skillId: string, deviceId: string, channel: Channel) => {
    return callApi<'ok'>({
        method: 'DELETE',
        url: routes.app.appStoreApi(`/apps/${skillId}/market-devices/drafts/${deviceId}`),
        queryParams: { channel },
    });
};

export const deletePublishedDevice = (skillId: string, deviceId: string, channel: Channel) => {
    return callApi<'ok'>({
        method: 'DELETE',
        url: routes.app.appStoreApi(`/apps/${skillId}/market-devices/${deviceId}`),
        queryParams: { channel },
    });
};

const searchMarketDevicesImpl = (text: string) => {
    const encodedText = encodeURIComponent(text);

    return callApi<MarketDevice[]>({
        method: 'GET',
        url: routes.app.appStoreApi('/market-devices/search', `?text=${encodedText}`),
    });
};

export const searchMarketDevices = mem(searchMarketDevicesImpl);

export const clearSearchCache = () => mem.clear(searchMarketDevices);
